import { BEHAVIOR_MODES, SCROLL_RESOLUTION } from "./stickyBannerConfig.types";

/** Defaults merged into page configs (override per file as needed). */
export const stickyBannerCommonDefaults = {
  defaultCtaText: "Book a Session",
  leadCaptureSource: "bottom_banner_tte",
  /** Carousel when behaviorMode is CAROUSEL (or fallback) */
  carouselIntervalMs: 5000,
  /** Hysteresis for “near bottom” milestone — reduces noisy toggling */
  scrollBottomEnterRatio: 0.86,
  scrollBottomExitRatio: 0.78,
  /**
   * Optional explicit DOM id for middle milestone (reports). Falls back to first
   * SCROLL_ELEMENT milestone’s targetElementId, then scroll-ratio middle band.
   */
  middleMilestoneTargetId: null,
  /** Scroll-ratio middle band when IO is absent or never fires (fraction of max scroll). */
  middleScrollEnterRatio: 0.35,
  middleScrollExitRatio: 0.3,
  /** Optional override for bottom enter (alias of scrollBottomEnterRatio when set). */
  bottomThreshold: null
};

export function mergeStickyBannerConfig(overrides) {
  return {
    ...stickyBannerCommonDefaults,
    ...overrides
  };
}

export function inferBehaviorMode(config) {
  if (config?.behaviorMode) return config.behaviorMode;
  const hasCarouselIds = config?.carouselMessageIds?.length > 0;
  const hasCarouselLegacy = config?.carouselMessages?.length > 0;
  if ((hasCarouselIds || hasCarouselLegacy) && !config?.scrollMilestones?.length && !config?.scrollTriggers?.length) {
    return BEHAVIOR_MODES.CAROUSEL;
  }
  if (config?.scrollMilestones?.length || config?.scrollTriggers?.length) {
    return BEHAVIOR_MODES.SCROLL;
  }
  if (config?.messageRules?.length) {
    return BEHAVIOR_MODES.CONDITIONS;
  }
  return BEHAVIOR_MODES.CONDITIONS;
}

export function inferScrollResolution(config) {
  if (config?.scrollResolution) return config.scrollResolution;
  if (config?.scrollMilestones?.length) return SCROLL_RESOLUTION.MILESTONE;
  return SCROLL_RESOLUTION.PRIORITY;
}
